import { ManagerSessionContext } from '@/features/auth/context/managerSessionContext';
import type { ManagerContext } from '@/features/auth/types/ManagerContext';

import type { PropsWithChildren } from 'react';

export function ManagerSessionProvider({
  context,
  children,
}: PropsWithChildren<{ context: ManagerContext }>) {
  return <ManagerSessionContext value={context}>{children}</ManagerSessionContext>;
}
